// Generated by Melange

import * as Buhta_cabinet__Btn from "../../components/html/Btn.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__ErrorPage from "../ErrorPage.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__FormView from "../../components/html/FormView.js";
import * as Buhta_cabinet__Kassa from "../../grpc/Kassa.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__ToastSender from "../../util/ToastSender.js";
import * as Buhta_components__CopyButton24 from "../../../../../packages/components/src/CopyButton24.js";
import * as Buhta_components__LoadingDiv from "../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(org) {
  return function (kkm) {
    const match = Buhta_core__Tenant.useTenant(undefined);
    const tenant = match[0];
    const initialFocusRef = React.useRef(null);
    const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
    const dispatchToasts = match$1[1];
    const contextRoute = function (route) {
      return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
    };
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
                      onSubmit: (function (param) {
                          
                        }),
                      initialFocusRef: initialFocusRef,
                      method_: "POST",
                      children: [
                        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                              label: "Модель",
                              type_: "text",
                              name: "model",
                              disabled: true,
                              inputClassName: "text-default-gray safari-disabled-input",
                              value: "Бухта 1.0"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.P.make, {
                                      className: "text-default-gray",
                                      children: kkm.serial_num
                                    }),
                                JsxRuntime.jsx(Buhta_components__CopyButton24.make, {
                                      text: kkm.serial_num
                                    }),
                                JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                      className: "absolute -top-2.5 left-2 bg-white px-2 text-gray-medium",
                                      children: "Серийный номер"
                                    })
                              ],
                              className: "rounded border border-gray-main px-4 py-3 mt-4 flex justify-between relative items-center"
                            }),
                        JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                              title: "Зарегистрировать",
                              onClick: (function (param) {
                                  const __x = Buhta_cabinet__Kassa.KkmManagerService.start(tenant, kkm.id, undefined);
                                  $$Promise.get(__x, (function (result) {
                                          if (result.TAG !== /* Ok */0) {
                                            return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы");
                                          }
                                          Buhta_cabinet__Route.navigateTo(contextRoute({
                                                    TAG: /* Kassa */2,
                                                    _0: /* Kkms */{
                                                      _0: /* List */1
                                                    }
                                                  }));
                                          Curry._1(dispatchToasts, {
                                                TAG: /* Add */0,
                                                _0: {
                                                  id: Buhta_core__Toast.generateId(undefined),
                                                  text: "ККМ успешно зарегистрирована",
                                                  kind: "success",
                                                  onClick: (function (param) {
                                                      
                                                    })
                                                }
                                              });
                                        }));
                                }),
                              className: "py-3 mt-6 w-full"
                            })
                      ]
                    }),
                className: "p-6"
              });
  };
}

function KkmStartPage$KkmStartForm(Props) {
  return make(Props.org)(Props.kkm);
}

const KkmStartForm = {
  make: KkmStartPage$KkmStartForm
};

function make$1(org) {
  return function (id) {
    return function (openMenu) {
      const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
      const deviceType = state.deviceType;
      const match = Buhta_core__Tenant.useTenant(undefined);
      const tenant = match[0];
      const contextRoute = function (route) {
        return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
      };
      const func = Buhta_cabinet__Kassa.KkmManagerService.view;
      const match$1 = Buhta_core__GrpcState.useModel((function (param) {
              return Curry._3(func, param, /* [] */0, id);
            }), undefined);
      const dispatch = match$1[1];
      const kkmObj = match$1[0];
      React.useEffect((function () {
              Curry._2(dispatch, undefined, undefined);
            }), [id]);
      Buhta_core__Toast.ToastsContext.useToasts(undefined);
      const closeButton = JsxRuntime.jsx(Buhta_cabinet__Link.make, {
            route: contextRoute({
                  TAG: /* Kassa */2,
                  _0: /* Kkms */{
                    _0: /* List */1
                  }
                }),
            children: JsxRuntime.jsx("img", {
                  src: StaticAsset.src("/static/icons/close-20.svg")
                })
          });
      const header = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
              title: "Регистрация кассы",
              leftChildren: closeButton,
              openMenu: openMenu
            }) : JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
              title: "Регистрация кассы"
            });
      return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
                  header: header,
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          deviceType === "mobile" ? null : JsxRuntime.jsx("div", {
                                  children: closeButton,
                                  className: "bg-white py-4.5 px-6 border-b border-gray-main w-full"
                                }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                              className: "mt-3 text-center",
                                              children: "Регистрация кассы"
                                            }),
                                        JsxRuntime.jsx("hr", {
                                              className: "mt-3"
                                            }),
                                        typeof kkmObj === "string" ? (
                                            kkmObj === "Loading" ? JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {}),
                                                    className: "p-6"
                                                  }) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
                                          ) : (
                                            kkmObj.NAME === "Data" ? JsxRuntime.jsx(KkmStartPage$KkmStartForm, {
                                                    org: org,
                                                    kkm: kkmObj.VAL
                                                  }) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
                                          )
                                      ],
                                      className: "bg-white w-full lg:w-106 border border-gray-main rounded-md shadow-kkms"
                                    }),
                                className: "py-6 lg:py-10 w-full px-4 lg:px-0 lg:flex lg:justify-center"
                              })
                        ],
                        className: "w-full flex flex-col items-center"
                      }),
                  className: "bg-gray-pale"
                });
    };
  };
}

function KkmStartPage(Props) {
  return Curry._1(make$1(Props.org)(Props.id), Props.openMenu);
}

const timeout = 3000;

const make$2 = KkmStartPage;

export {
  timeout ,
  KkmStartForm ,
  make$2 as make,
}
/* Buhta_cabinet__Btn Not a pure module */
